
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as bloguNGut8OsK3QrFWTu_cCHIcQ_457Zak81_avDcBTVOgbEEMeta } from "/opt/buildhome/repo/pages/blog.vue?macro=true";
import { default as about6Vgf2e_45ZWwa_45DDxcsm2LFgKBFkBxwt_su_XdCkSeybIMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as planstWGR4_45aRqZB_45R_NtlriSQsGVcw4UdyOHDcvN9a764_IMeta } from "/opt/buildhome/repo/pages/plans.vue?macro=true";
import { default as careersrtrgUQj52TdbMt0kFBEVGh7IuHaMPsxHAEBw6tGV_45OUMeta } from "/opt/buildhome/repo/pages/careers.vue?macro=true";
import { default as contactxgbCBTXU_45d0XJYTpbmfD1UGZKjSEtzA80xt962KkT7QMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as platformnJGJF45Cp0SEJia3OkTUZf6JvOsKvFNu0UgbZyIgcAAMeta } from "/opt/buildhome/repo/pages/platform.vue?macro=true";
import { default as _91_46_46_46slug_93kxjr4BRGYu8PjICw6eKIYYGNlIv1T0FK9GFhjf_45hT6QMeta } from "/opt/buildhome/repo/pages/[...slug].vue?macro=true";
import { default as disclaimerGJKKeisaMeBOuTtB_45PmpqHUugF_45CBsRxH7gnKm_87m0Meta } from "/opt/buildhome/repo/pages/disclaimer.vue?macro=true";
import { default as index0v_4599X6BjoN7rkqBDw0pjTpHUEvxQysgZr2clb9r59MMeta } from "/opt/buildhome/repo/pages/news/index.vue?macro=true";
import { default as test_45modaldOp8Z_45pgMhAITcrZz6Xw2Y2jqKgWEkP90uXVIFZNuOMMeta } from "/opt/buildhome/repo/pages/test-modal.vue?macro=true";
import { default as ccpa_45policyOjHgLfM67pq2PjiBtWlzgrS2Pcl6lDLqstZWHDpltx4Meta } from "/opt/buildhome/repo/pages/ccpa-policy.vue?macro=true";
import { default as chartRk_c5wH6HfEWGAMQr4zXfXL2vc0KVLE7QpXjM2ZkGlIMeta } from "/opt/buildhome/repo/pages/embed/chart.vue?macro=true";
import { default as index18Q0NxznJUDNyQYVJfY4upidYG_4Bfu6NM5u966ahJMMeta } from "/opt/buildhome/repo/pages/scans/index.vue?macro=true";
import { default as top_45featuresdkYjm_x72yHOSiOrcHaaC0pNRrjbIw3yoSB9bhnRxqoMeta } from "/opt/buildhome/repo/pages/top-features.vue?macro=true";
import { default as ai_45disclosureRItk6FAuWJYcM7SbZfNDF1OUAn9zVsXYtWl8rTegSfkMeta } from "/opt/buildhome/repo/pages/ai-disclosure.vue?macro=true";
import { default as cookie_45policyMIFETaySFO4h2vvjlHBOZNyTe_k1Vy9bHWMdPvEBTrUMeta } from "/opt/buildhome/repo/pages/cookie-policy.vue?macro=true";
import { default as _91_46_46_46slug_93ZySbWuWn1jSYDKSNhP4MFqlpeqXxSz1jYpkAc9yGIasMeta } from "/opt/buildhome/repo/pages/tag/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93Jxb8LGrit9ZcPIemFD2h_Jzf0St1HDk9Mscvz26OvnkMeta } from "/opt/buildhome/repo/pages/news/[...slug].vue?macro=true";
import { default as privacy_45policyek63hKQ8ZMx2nIQV88L2_dad1Zv4m5Ym_n4RQ7NuSXAMeta } from "/opt/buildhome/repo/pages/privacy-policy.vue?macro=true";
import { default as test_45modal_45xhrzAHYRJj55NdXYMxxwLkx8cEN_YZsgLIy8fKSCedQjYcMeta } from "/opt/buildhome/repo/pages/test-modal-xhr.vue?macro=true";
import { default as _91_46_46_46id_93gfvdHBEx_icPzdOXVHdG07RVHLpChGvENEcrJK4J_45X4Meta } from "/opt/buildhome/repo/pages/category/[...id].vue?macro=true";
import { default as _91_46_46_46stock_939HoR_ezC9KqOg1iHmPPUWnHL6i8mwnMcHa7lApuHu_kMeta } from "/opt/buildhome/repo/pages/quote/[...stock].vue?macro=true";
import { default as broker_45integration2F3zdHRH7WaIPEdMcWzh_45RxakWRwS5DN84grgp4GhucMeta } from "/opt/buildhome/repo/pages/broker-integration.vue?macro=true";
import { default as stock_45loserskz5RGGE_45QR_MZgEmC91dhlJhFapsbNroYzP7A_H0eMMMeta } from "/opt/buildhome/repo/pages/scans/stock-losers.vue?macro=true";
import { default as stock_45gainersVT1wyo4vKQmoUW6WXhj8_45x_45GuVhs20KOmy0jIsQ18_45wMeta } from "/opt/buildhome/repo/pages/scans/stock-gainers.vue?macro=true";
import { default as system_45requirementsp6Crra1zwDGppY9IY5Qp7vzssq7bncNrxgLHZtmVksUMeta } from "/opt/buildhome/repo/pages/system-requirements.vue?macro=true";
import { default as affiliate_45disclosurejoYcFvZleYcgRJzcoUE4_QS9tWRFDz4nqpNruO56C90Meta } from "/opt/buildhome/repo/pages/affiliate-disclosure.vue?macro=true";
import { default as dmca_45takedown_45policyutnibTfs_Gke9mE6lH8NMYHyMh1o8_NgVC8JRrI0ex0Meta } from "/opt/buildhome/repo/pages/dmca-takedown-policy.vue?macro=true";
import { default as editorial_45guidelinesfF_ofOV_tGDJQJc0tiy02m6jSkWt7aT4yWWCwKWJjw0Meta } from "/opt/buildhome/repo/pages/editorial-guidelines.vue?macro=true";
import { default as _91_46_46_46author_45name_93YeQ5Hiz7n0hZ3kFAMRIZ7SoGL1umrY1NFd01IqVkH_45oMeta } from "/opt/buildhome/repo/pages/authors/[...author-name].vue?macro=true";
import { default as highest_45volume_45stocks_45jkPN_AEUIXKgrr28z2ctZaPQPPhliOZVkX5lT_JLvgMeta } from "/opt/buildhome/repo/pages/scans/highest-volume-stocks.vue?macro=true";
import { default as unusual_45volume_45stocksmx_sMMX9AT2IzTEwQlJx6WFDpfNyjC_45oRJvxuncuGp8Meta } from "/opt/buildhome/repo/pages/scans/unusual-volume-stocks.vue?macro=true";
import { default as terms_45service_45use_45agreement9q57LglHTSg4I03ptJuk679cYaLWeKbiQ05BhqxpvA0Meta } from "/opt/buildhome/repo/pages/terms-service-use-agreement.vue?macro=true";
import { default as disclosure_45of_45related_45and_45partner_45entities87hWiV4urb203_Wo7VnZ1DGkHMYhOvImkUSBd9X_45168Meta } from "/opt/buildhome/repo/pages/disclosure-of-related-and-partner-entities.vue?macro=true";
export default [
  {
    name: "blog",
    path: "/blog",
    component: () => import("/opt/buildhome/repo/pages/blog.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "plans",
    path: "/plans",
    component: () => import("/opt/buildhome/repo/pages/plans.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/opt/buildhome/repo/pages/careers.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "platform",
    path: "/platform",
    component: () => import("/opt/buildhome/repo/pages/platform.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/[...slug].vue")
  },
  {
    name: "disclaimer",
    path: "/disclaimer",
    component: () => import("/opt/buildhome/repo/pages/disclaimer.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/opt/buildhome/repo/pages/news/index.vue")
  },
  {
    name: "test-modal",
    path: "/test-modal",
    component: () => import("/opt/buildhome/repo/pages/test-modal.vue")
  },
  {
    name: "ccpa-policy",
    path: "/ccpa-policy",
    component: () => import("/opt/buildhome/repo/pages/ccpa-policy.vue")
  },
  {
    name: "embed-chart",
    path: "/embed/chart",
    meta: chartRk_c5wH6HfEWGAMQr4zXfXL2vc0KVLE7QpXjM2ZkGlIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/embed/chart.vue")
  },
  {
    name: "scans",
    path: "/scans",
    component: () => import("/opt/buildhome/repo/pages/scans/index.vue")
  },
  {
    name: "top-features",
    path: "/top-features",
    component: () => import("/opt/buildhome/repo/pages/top-features.vue")
  },
  {
    name: "ai-disclosure",
    path: "/ai-disclosure",
    component: () => import("/opt/buildhome/repo/pages/ai-disclosure.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/opt/buildhome/repo/pages/cookie-policy.vue")
  },
  {
    name: "tag-slug",
    path: "/tag/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/tag/[...slug].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/news/[...slug].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/buildhome/repo/pages/privacy-policy.vue")
  },
  {
    name: "test-modal-xhr",
    path: "/test-modal-xhr",
    component: () => import("/opt/buildhome/repo/pages/test-modal-xhr.vue")
  },
  {
    name: "category-id",
    path: "/category/:id(.*)*",
    component: () => import("/opt/buildhome/repo/pages/category/[...id].vue")
  },
  {
    name: "quote-stock",
    path: "/quote/:stock(.*)*",
    component: () => import("/opt/buildhome/repo/pages/quote/[...stock].vue")
  },
  {
    name: "broker-integration",
    path: "/broker-integration",
    component: () => import("/opt/buildhome/repo/pages/broker-integration.vue")
  },
  {
    name: "scans-stock-losers",
    path: "/scans/stock-losers",
    component: () => import("/opt/buildhome/repo/pages/scans/stock-losers.vue")
  },
  {
    name: "scans-stock-gainers",
    path: "/scans/stock-gainers",
    component: () => import("/opt/buildhome/repo/pages/scans/stock-gainers.vue")
  },
  {
    name: "system-requirements",
    path: "/system-requirements",
    component: () => import("/opt/buildhome/repo/pages/system-requirements.vue")
  },
  {
    name: "affiliate-disclosure",
    path: "/affiliate-disclosure",
    component: () => import("/opt/buildhome/repo/pages/affiliate-disclosure.vue")
  },
  {
    name: "dmca-takedown-policy",
    path: "/dmca-takedown-policy",
    component: () => import("/opt/buildhome/repo/pages/dmca-takedown-policy.vue")
  },
  {
    name: "editorial-guidelines",
    path: "/editorial-guidelines",
    component: () => import("/opt/buildhome/repo/pages/editorial-guidelines.vue")
  },
  {
    name: "authors-authorname",
    path: "/authors/:authorname(.*)*",
    component: () => import("/opt/buildhome/repo/pages/authors/[...author-name].vue")
  },
  {
    name: "scans-highest-volume-stocks",
    path: "/scans/highest-volume-stocks",
    component: () => import("/opt/buildhome/repo/pages/scans/highest-volume-stocks.vue")
  },
  {
    name: "scans-unusual-volume-stocks",
    path: "/scans/unusual-volume-stocks",
    component: () => import("/opt/buildhome/repo/pages/scans/unusual-volume-stocks.vue")
  },
  {
    name: "terms-service-use-agreement",
    path: "/terms-service-use-agreement",
    component: () => import("/opt/buildhome/repo/pages/terms-service-use-agreement.vue")
  },
  {
    name: "disclosure-of-related-and-partner-entities",
    path: "/disclosure-of-related-and-partner-entities",
    component: () => import("/opt/buildhome/repo/pages/disclosure-of-related-and-partner-entities.vue")
  }
]